







import Vue from 'vue'

function uploadPhoto(url: string, data: any) {
    return $.ajax({
        url: url,
        type: 'POST',
        data: data,
        cache: false,
        dataType: 'json',
        processData: false,
        contentType: false
    })
}

export default Vue.extend({
    props: ['uploadUrl', 'url', 'className', 'hasPhoto'],
    data() {
        return {}
    },
    methods: {
        uploadPhoto(e: any) {            
            var files = e.target.files || e.dataTransfer.files
            if (!files.length)
                return
            let data = new FormData()
            data.append('photo', files[0])
            uploadPhoto(this.uploadUrl, data).done((res: any) => {
                if (res.status == 'fail') {
                    return
                }
                this.$emit('upload', res.data.url)
            })
        }
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/form/UploadPhoto.vue